(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelEngineComparison'
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/HotelEngine/comparison', function onload() {
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load()
	{
		$('.hide-pricing').on('change', function toggle() {
			if ($(this).is(':checked')) {
				$('.disable-booking').addClass('hidden');
			} else {
				$('.disable-booking').removeClass('hidden');
			}
		});
	};
}(jQuery, window.Adzuki || {}));
